import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const version = 'v1';

const endpointUsuarios = `/${version}/usuarios`;

export const RECUPERAR_USUARIOS_ENDPOINT = `/${version}/usuarios`;

export function useUsuariosService() {
  const { backendGet, backendPost, backendPut, backendDelete } =
    Sebrae.useBackend();

  const [userList] = React.useState([]);

  const getPermissoes = React.useCallback(
    () => backendGet(`${endpointUsuarios}/permissoes`),
    [backendGet],
  );

  const getPermissoesId = React.useCallback(
    (id) => backendGet(`${endpointUsuarios}/${id}`),
    [backendGet],
  );

  const getPermissoesUsuarioAmei = React.useCallback(
    (cpfOuEmail) => backendGet(`${endpointUsuarios}/amei/${cpfOuEmail}`),
    [backendGet],
  );

  const getPermissoesUsuario = React.useCallback(
    (cpfOuEmail) =>
      backendGet(`${endpointUsuarios}/cpf-ou-email/${cpfOuEmail}`),
    [backendGet],
  );

  const getPerfis = React.useCallback(
    () => backendGet(`${endpointUsuarios}/perfis`),
    [backendGet],
  );

  const getTodosPerfis = React.useCallback(
    () => backendGet(`${endpointUsuarios}/perfis-todos`),
    [backendGet],
  );

  const getUfs = React.useCallback(
    () => backendGet(`${version}/ufs`),
    [backendGet],
  );

  const postCadastrarUsuario = React.useCallback(
    (usuarioDTO) => backendPost(`${endpointUsuarios}`, usuarioDTO),
    [backendPost],
  );

  const putAutorizarUsuario = React.useCallback(
    (listaUsuarios) =>
      backendPut(`${endpointUsuarios}/autorizar`, [listaUsuarios]),
    [backendPut],
  );

  const getHistoricoUsuario = React.useCallback(
    (id) => backendGet(`${endpointUsuarios}/historico/${id}`),
    [backendGet],
  );

  const deletaPermissaoUsuario = React.useCallback(
    (id) => backendDelete(`${endpointUsuarios}/${id}`),
    [backendDelete],
  );

  return {
    userList,
    getPermissoes,
    getPermissoesId,
    getPerfis,
    getTodosPerfis,
    getUfs,
    getPermissoesUsuarioAmei,
    getPermissoesUsuario,
    postCadastrarUsuario,
    putAutorizarUsuario,
    deletaPermissaoUsuario,
    getHistoricoUsuario,
    RECUPERAR_USUARIOS_ENDPOINT,
  };
}
